import type { ComponentWithChildren } from '@polyai/common/types/helpers';

import { cn } from '../../../utils/cn';

type GridContentProps = {
  className?: string;
  isSidebarOpen?: boolean;
};

const GridContent: ComponentWithChildren<GridContentProps> = ({
  className,
  isSidebarOpen,
  children,
}) => {
  return (
    <div
      className={cn(
        'w-full max-w-[75rem] mx-auto p-sm4 max-xs:p-sm3',
        isSidebarOpen && 'basis-[calc(100%-415px)] w-[unset] max-lg:basis-full',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default GridContent;
